let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eAqp7")).then(() => parcelRequire('8zEpB'));